export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="font-heading text-lg text-foreground-950 mb-3">YY漫画</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              YY漫画网是国内领先的免费漫画在线阅读平台，汇聚海量韩漫、日漫、国漫资源，支持下拉式阅读和追更收藏，为漫画爱好者提供最优质的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">首页</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">人气榜单</a></li>
              <li><a href="#topics" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#updates" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">追更动态</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-3">漫画分类</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">韩漫精选</a></li>
              <li><a href="#index" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">日漫精选</a></li>
              <li><a href="#index" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">国漫精选</a></li>
              <li><a href="#index" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">已完结</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-3">合作伙伴</h4>
            <p className="text-sm text-foreground-500">合作品牌陆续入驻中</p>
            <ul className="space-y-1 mt-2">
              <li className="text-sm text-foreground-400">—— 虚位以待 ——</li>
              <li className="text-sm text-foreground-400">—— 虚位以待 ——</li>
              <li className="text-sm text-foreground-400">—— 虚位以待 ——</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2022-2026 YY漫画网 · 韩漫、日漫、国漫免费阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">联系我们</a>
            <span className="text-xs text-foreground-400">|</span>
            <span className="text-xs text-foreground-500">本站内容仅供阅读交流</span>
          </div>
        </div>
      </div>
    </footer>
  );
}